export const GET_ALL_VISITORS_REQUEST = 'GET_ALL_VISITORS_REQUEST';
export const GET_ALL_VISITORS_SUCCESS = 'GET_ALL_VISITORS_SUCCESS';
export const GET_ALL_VISITORS_FAILURE = 'GET_ALL_VISITORS_FAILURE';

export const ADD_VISITOR_REQUEST = 'ADD_VISITOR_REQUEST';
export const ADD_VISITOR_SUCCESS = 'ADD_VISITOR_SUCCESS';
export const ADD_VISITOR_FAILURE = 'ADD_VISITOR_FAILURE';

export const GET_VISITOR_BY_ID_REQUEST = 'GET_VISITOR_BY_ID_REQUEST';
export const GET_VISITOR_BY_ID_SUCCESS = 'GET_VISITOR_BY_ID_SUCCESS';
export const GET_VISITOR_BY_ID_FAILURE = 'GET_VISITOR_BY_ID_FAILURE';

export const ACTIVATE_VISITOR_REQUEST = 'ACTIVATE_VISITOR_REQUEST';
export const ACTIVATE_VISITOR_SUCCESS = 'ACTIVATE_VISITOR_SUCCESS';
export const ACTIVATE_VISITOR_FAILURE = 'ACTIVATE_VISITOR_FAILURE';

export const GET_VISITORS_BY_CP_REQUEST = 'GET_VISITORS_BY_CP_REQUEST';
export const GET_VISITORS_BY_CP_SUCCESS = 'GET_VISITORS_BY_CP_SUCCESS';
export const GET_VISITORS_BY_CP_FAILURE = 'GET_VISITORS_BY_CP_FAILURE';
